import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { FiDownload } from 'react-icons/fi'
import { device } from '../components/Breakpoints'
import { colors } from '../components/Colors'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
}
`
const GroupContent = styled.section`
  padding: 2em 0;

  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }

  .icons {
    flex-wrap: wrap !important;
    div {
      width: 50%;
      @media ${device.mobileL} {
        width: 100%;
        min-width: 100%;
      }
    }
    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
      li {
        width: 50%;
        min-width: 50%;
        list-style: none;
        box-sizing: border-box;
        padding: 1em;
        font-size: 0.8em;
        @media ${device.mobileL} {
          width: 100%;
          min-width: 100%;
          text-align: left;
        }
        img {
          width: 40px;
          height: auto;
          margin: 0 10px 0 0;
          vertical-align: middle;
        }
      }
    }
  }
  .video {
    h3 {
      display: block;
      text-align: center;
      margin-bottom: 0;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /**
      Target IE11
      */
        margin: 0 !important;
      }
    }
    iframe {
      margin: 40px 0;
      @media ${device.mobileL} {
        height: 260px;
      }
    }

    ul {
      padding: 0;
      margin: 1em 0 0;
      li {
        margin: 0 0 1.5em 0;
        padding: 0;
        list-style: none;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        a {
          width: 100%;
          max-width: 180px;
          height: 50px;
          text-align: center;
          flex-grow: 0;
          background-color: #ffffff;
          padding: 0 2.3em;
          border-radius: 50px;
          text-transform: uppercase;
          font-size: 0.8em;
          text-decoration: none;
          color: #ff8f8c;
          opacity: 1;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          :hover {
            opacity: 0.8;
          }
          svg {
            color: ${colors.verde};
          }
          @media ${device.mobileL} {
            margin: auto;
          }
        }
        .linkHeader {
          background: #793939;
          padding: 0.5em 2em;
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media ${device.mobileL} {
            flex-wrap: wrap;
            padding: 2em;
          }
          a {
            background: #ffffff;
            color: #ff8f8c;
            svg {
              color: #793939;
            }
          }
          h3 {
            color: ${colors.branco};
            font-size: 1em;
            position: relative;
            padding: 0.6 em 0;
            font-weight: normal;
            margin: 1em 0;
            :before {
              position: absolute;
              content: '';
              top: -10px;
              left: 0;
              border: 1px solid #a57777;
              width: 5%;
              @media ${device.mobileL} {
                left: 45%;
                width: 10%;
              }
            }
            :after {
              position: absolute;
              content: '';
              bottom: -10px;
              left: 0;
              border: 1px solid #a57777;
              width: 5%;
              @media ${device.mobileL} {
                left: 45%;
                width: 10%;
              }
            }
            @media ${device.mobileL} {
              width: 100%;
              text-align: center;
              margin-bottom: 2em;
            }
          }
        }
        .linkDescription {
          padding: 1em 3em;
          p {
            color: ${colors.cinza};
            font-size: 0.9em;
          }
        }
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    img {
      margin: 30px -20px 0 20px;
      height: 100%;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
  }

  :nth-of-type(odd) {
    background: linear-gradient(to top, #c3c4e8, #8e8fc7);
    color: #ffffff;
  }
  :nth-of-type(even) {
    h3 {
      color: #8e8fc7;
    }
  }
  :nth-of-type(5) {
    background: linear-gradient(to top, #8accb7, #006a65);
  }
`
export const ProtocoloSifilisTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Para médicos',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          height="204px"
        />

        <GroupContent>
          <div className="center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="video center">
            <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
            {parse(sessoes[1].texto)}
            <ul>
              <li>
                <div className="linkHeader">
                  <h3>{parse(sessoes[2].linksExternos[0].titulo)}</h3>
                  <a
                    href={parse(sessoes[2].linksExternos[0].url)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                    <FiDownload />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

ProtocoloSifilisTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const ProtocoloSifilis = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <ProtocoloSifilisTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

ProtocoloSifilis.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ProtocoloSifilis

export const ProtocoloSifilisQuery = graphql`
  query ProtocoloSifilisById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          linksExternos {
            descricao
            titulo
            url
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
